import { apiClient } from "../apiClient";

export const THANH_PHAN_THI_ENDPOINT = "thanh-phan-thi";
export const thanhPhanThiApi = {
    SelectAll: () => apiClient.get(`${THANH_PHAN_THI_ENDPOINT}`),
    Insert: (payload: any) => apiClient.post(`${THANH_PHAN_THI_ENDPOINT}`, payload),
    Update: (id: number, payload: any) => apiClient.put(`${THANH_PHAN_THI_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${THANH_PHAN_THI_ENDPOINT}/${id}`)
};